import { ContentItem } from '@/types/cms';

export const events: Record<string, ContentItem> = {
  "eab-connected25": {
    id: "eab-connected25",
    type: "event",
    category: "webinar",
    title: "CONNECTED25",
    description: "StudyStash is joining EAB's CONNECTED25 conference in Orlando this October!",
    slug: "eab-connected25",
    publishDate: "2024-11-20",
    readingTime: "6 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/connected-25-bg.png",
      imageAlt: "EAB CONNECTED25 logo"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Overview"
      },
      {
        type: "paragraph",
        text: "We're excited to not only attend EAB CONNECTED25 this October in Orlando, but join as a Silver partner! The conference is set to be an unmissable meeting of minds for higher education leaders, innovators, and student success practitioners."
      },
      {
        type: "image",
        src: "/eab-connected25-event.png",
        alt: "EAB CONNECTED25",
        width: 1000,
        height: 1000
      },
      {
        type: "heading",
        level: 2,
        text: "Event Details"
      },
      {
        type: "paragraph",
        text: "CONNECTED25 brings together over a thousand educators, institutions, and EdTech innovators to share insights, explore new approaches, and advance student success at scale. It's a powerful space to learn, connect, and shape the future of higher education together, and we're looking forward to networking and note-taking."
      },
      {
        type: "statistics",
        stats: [
          {
            value: "Orlando, FL",
            title: "Location",
            description: "13th - 15th October 2025",
            color: "blue"
          },
          {
            value: "1000+",
            title: "Attendees",
            description: "Student success leaders and EdTech partners",
            color: "green"
          },
          {
            value: "The Journey",
            title: "Theme",
            description: "to Student Ready",
            color: "purple"
          }
        ],
        layout: "grid"
      },
      {
        type: "quote",
        text: "Come and say hello to the StudyStash team, see our platform in action, and learn about how helping students and institutions simplify studying and driving better outcomes!",
        author: "Joana Williams",
        title: "StudyStash | Senior Marketing Executive",
        image: "/team/joanna_williams.jpeg"
      },
      {
        type: "heading",
        level: 2,
        text: "Interested to hear more"
      },
      {
        type: "paragraph",
        text: "If you want to hear more about our CONNECTED25 offer, click below to learn about our special conference offer."
      },
      {
        type: "button-row",
        buttons: [
          {
            type: "cta-button",
            text: "CONNECTED25 Pilot Offer",
            href: "/pilot-program-eab-connected25",
            variant: "primary",
            size: "lg"
          },
          {
            type: "cta-button",
            text: "Download the EAB case-study",
            variant: "outline",
            size: "lg",
            href: "#",
            showModal: "eab-case-study"
          }
        ]
      }
    ],
    
    seo: {
      title: "StudyStash at EAB CONNECTED25 | StudyStash",
      description: "Join StudyStash at EAB's CONNECTED25 in Orlando this October. As a Silver Partner, we're excited to connect with education leaders, share our platform, and discuss how our EdTech can improve student success.",
      canonical: "https://studystash.com/about/events-webinars/eab-connected25"
    },
    
    relatedContent: ["educause", "annual-association-of-colleges"]
  },
  "educause": {
    id: "educause",
    type: "event",
    category: "webinar",
    title: "EDUCAUSE Annual Conference 2025",
    description: "We're delighted to be attending the 2025 EDUCAUSE Annual Conference.",
    slug: "educause",
    publishDate: "2024-10-15",
    readingTime: "5 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/educause_2025_conference.png",
      imageAlt: "EDUCAUSE logo"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Showcasing Innovation in Education"
      },
      {
        type: "paragraph",
        text: "StudyStash is joining EDUCAUSE for their 2025 Annual Conference, as part of the Emerging Tech Experience cohort, and we're thrilled to be joining the premiere worldwide conference for education technology."
      },
      {
        type: "heading",
        level: 2,
        text: "Visit Our Stand"
      },
      {
        type: "paragraph",
        text: "Be sure to visit our stand for insights into our innovative AI-platform, to get a demo in-person, and find out more about how we're transforming adaptive learning for staff, students, universities and FE institutions around the world!"
      },
      {
        type: "quote",
        text: "Come see us at our stand as we demonstrate how neuroscience is changing the landscape of teaching and learning in institutes across the UK and US.",
        author: "Joanna Williams",
        title: "StudyStash | Senior Marketing Executive",
        image: "/team/joanna_williams.jpeg"
      },
      {
        type: "heading",
        level: 2,
        text: "Interested in hearing more"
      },
      {
        type: "paragraph",
        text: "Want to learn more about our EDUCAUSE conference offer? Click below to discover our special conference package."
      },
      {
        type: "cta-button",
        text: "Hear about our pilot program?",
        href: "/pilot-program-educause-25",
        variant: "primary",
        size: "lg"
      }
    ],
    
    seo: {
      title: "StudyStash to Attend EDUCAUSE 2025 in Nashville | StudyStash",
      description: "Join StudyStash at EDUCAUSE 2025 in Nashville. As part of the Emerging Tech Experience cohort, we're showcasing our AI-powered adaptive learning platform built on neuroscience.",
      canonical: "https://studystash.com/about/events-webinars/educause"
    },
    
    relatedContent: ["eab-connected25", "annual-association-of-colleges"]
  },
  "altc25": {
    id: "altc25",
    type: "event",
    category: "webinar",
    title: "ALTC25",
    description: "StudyStash is heading to Glasgow on 23-24th October for the 2025 Association for Learning Technology's Annual Conference!",
    slug: "altc25",
    publishDate: "2025-10-23",
    readingTime: "4 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/ALTC.png",
      imageAlt: "ALTC25 logo"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Overview"
      },
      {
        type: "paragraph",
        text: "This October, we're excited to be joining one of the UK's biggest gatherings of learning technologists, researchers, and EdTech innovators at ALT Annual Conference 2025."
      },
      {
        type: "image",
        src: "/ALT2024.jpg",
        alt: "ALT Conference 2024",
        width: 1000,
        height: 1000
      },
      {
        type: "heading",
        level: 2,
        text: "Join Us in Glasgow"
      },
      {
        type: "paragraph",
        text: "At ALTC25 we'll be connecting with learning technologists, researchers, and innovators from across the learning technology sector to share insights, spark collaboration, and explore the future of digital learning. Our team will be showcasing how StudyStash turns complex lecture materials into interactive, personalised study tools, helping students achieve more success with less stress."
      },
      {
        type: "statistics",
        stats: [
          {
            value: "Glasgow",
            title: "Location",
            description: "United Kingdom",
            color: "blue"
          },
          {
            value: "23rd - 24th",
            title: "Dates",
            description: "October 2025",
            color: "green"
          },
          {
            value: "Stronger Foundations",
            title: "Mission",
            description: "Broader Horizons",
            color: "purple"
          }
        ],
        layout: "grid"
      },
      {
        type: "heading",
        level: 2,
        text: "See StudyStash in Action"
      },
      {
        type: "paragraph",
        text: "Drop by our stand to meet the team, explore the platform, and discover how we're helping universities and colleges to drive better learning outcomes with our cognitive neuroscience-backed app."
      },
      {
        type: "quote",
        text: "We're looking forward to connecting and collaborating with the ALT community, as we demonstrate first-hand how StudyStash is making digital learning smarter, simpler, and more effective.",
        author: "Joanna Williams",
        title: "StudyStash | Customer Success Manager",
        image: "/team/joanna_williams.jpeg"
      },
      {
        type: "heading",
        level: 2,
        text: "Want to learn more?"
      },
      {
        type: "paragraph",
        text: "Discover our ALTC 2025 offer, or get in touch with our team."
      },
      {
        type: "cta-button",
        text: "ALTC 2025 offer",
        href: "/pilot-program",
        variant: "primary",
        size: "lg"
      }
    ],
    
    seo: {
      title: "StudyStash at ALTC25 in Glasgow | StudyStash",
      description: "StudyStash is heading to Glasgow on 23-24th October for the 2025 Association for Learning Technology's Annual Conference! Join us to explore the future of digital learning.",
      canonical: "https://studystash.com/about/events-webinars/altc25"
    },
    
    relatedContent: ["educause", "eab-connected25", "annual-association-of-colleges"]
  },

  "annual-association-of-colleges": {
    id: "annual-association-of-colleges",
    type: "event",
    category: "webinar",
    title: "AoC 2025",
    description: "StudyStash is delighted to be exhibiting at the 2025 AoC Annual Conference and Trade show in Birmingham from the 18th - 19th November!",
    slug: "annual-association-of-colleges",
    publishDate: "2025-11-18",
    readingTime: "3 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/AOC-bg-blue.png",
      imageAlt: "AOC logo"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Overview"
      },
      {
        type: "paragraph",
        text: "We'll be joining a host of EdTech innovators who are shaping the UK education landscape."
      },
      {
        type: "statistics",
        stats: [
          {
            value: "Birmingham",
            title: "Location",
            description: "ICC, United Kingdom",
            color: "blue"
          },
          {
            value: "18th - 19th",
            title: "Dates",
            description: "November, 2025",
            color: "green"
          },
          {
            value: "Collaborating",
            title: "Mission",
            description: "to innovate student success",
            color: "purple"
          }
        ],
        layout: "grid"
      },
      {
        type: "heading",
        level: 2,
        text: "Headline Sponsor"
      },
      {
        type: "paragraph",
        text: "We're delighted to be joining Pearson, the headline sponsor of AoC Annual Conference and Exhibition 2025, in their mission to advance learning and transform lives through education."
      },
      {
        type: "heading",
        level: 2,
        text: "Join Us in Birmingham"
      },
      {
        type: "paragraph",
        text: "We'll be joining hundreds of college leaders, educators, and EdTech innovators to explore new ideas, share best practices, and discuss the future of learning. Our team will be on-site at our stand, ready to demonstrate how our platform transforms lecture notes into personalised learning tools that make studying smarter, simpler, and more effective."
      },
      {
        type: "heading",
        level: 2,
        text: "Experience StudyStash"
      },
      {
        type: "paragraph",
        text: "Stop by to meet the team, see StudyStash in action, and discover practical ways we're helping students and colleges improve learning outcomes."
      },
      {
        type: "quote",
        text: "We are looking forward to working with the colleges attending to support their AI strategies and boost student success.",
        author: "Alan Teece",
        title: "StudyStash | Chief Marketing Officer",
        image: "/team/alan.jpg"
      },
      {
        type: "heading",
        level: 2,
        text: "Interested to hear more?"
      },
      {
        type: "paragraph",
        text: "Read more about our AoC 2025 offer and get in touch with our team."
      },
      {
        type: "cta-button",
        text: "Read more",
        href: "https://studystash.com/pilot-program-fe-colleges",
        variant: "primary",
        size: "md"
      }
    ],
    
    seo: {
      title: "StudyStash at AoC Annual Conference 2025",
      description: "StudyStash is delighted to be exhibiting at the 2025 AoC Annual Conference and Trade show in Birmingham from the 18th - 19th November!",
      canonical: "https://studystash.com/about/events-webinars/annual-association-of-colleges-2025"
    },
    
    relatedContent: ["educause", "eab-connected25"]
  },
  "digifest": {
    id: "digifest",
    type: "event",
    category: "webinar",
    title: "Jisc | Digifest 2026",
    description: "StudyStash is delighted to be exhibiting at Jisc's Digifest 2026 in Birmingham!",
    slug: "digifest",
    publishDate: "2026-03-09",
    readingTime: "4 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/digifest_2025_jisc.png",
      imageAlt: "Jisc Digifest 2026 logo"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Overview"
      },
      {
        type: "paragraph",
        text: "We're excited to be joining Jisc's Digifest 2026, the UK's leading festival for digital transformation in education and research. In 2026, the theme is 'From disruption to direction', exploring how technology can create ethical, inclusive, and human-centred futures."
      },
      {
        type: "image",
        src: "/jisc.png",
        alt: "Jisc logo",
        width: 100,
        height: 50
      },
      {
        type: "heading",
        level: 2,
        text: "Event Details"
      },
      {
        type: "paragraph",
        text: "Digifest is the UK's premier digital transformation festival for education and research. It's where education leaders, technology innovators, and digital pioneers come together to shape the future of learning and research through technology."
      },
      {
        type: "statistics",
        stats: [
          {
            value: "Birmingham",
            title: "Location",
            description: "ICC Birmingham",
            color: "blue"
          },
          {
            value: "9th - 10th",
            title: "Dates",
            description: "March 2026",
            color: "green"
          },
          {
            value: "Ethical, inclusive",
            title: "Focus",
            description: "and human-centred digital futures in education",
            color: "purple"
          }
        ],
        layout: "grid"
      },
      {
        type: "heading",
        level: 2,
        text: "Meet Our Team"
      },
      {
        type: "paragraph",
        text: "Visit our stand to meet the StudyStash team and discover how our AI-powered platform is transforming how students learn and institutions support student success. We'll be showcasing our latest innovations in adaptive learning and study tools."
      },
      {
        type: "quote",
        text: "Digifest is the perfect place to connect with education leaders who are driving digital transformation. We're excited to share how StudyStash is helping institutions leverage AI to improve student outcomes.",
        author: "Joanna Williams",
        title: "StudyStash | Senior Marketing Executive",
        image: "/team/joanna_williams.jpeg"
      },
      {
        type: "heading",
        level: 2,
        text: "Want to learn more?"
      },
      {
        type: "paragraph",
        text: "Discover our Digifest 2026 offer or get in touch with our team to learn more about how StudyStash can support your digital transformation goals."
      },
      {
        type: "cta-button",
        text: "Join the pilot",
        href: "/pilot-program",
        variant: "primary",
        size: "lg"
      }
    ],
    
    seo: {
      title: "StudyStash at Jisc Digifest 2026 | StudyStash",
      description: "StudyStash is delighted to be exhibiting at Jisc's Digifest 2026 in Birmingham! Join us to explore digital transformation in education.",
      canonical: "https://studystash.com/about/events-webinars/digifest"
    },
    
    relatedContent: ["educause", "eab-connected25", "annual-association-of-colleges"]
  },
  "proapptive-partnership": {
    id: "proapptive-partnership",
    type: "event",
    category: "webinar",
    title: "StudyStash partners with ProApptive",
    description: "StudyStash is collaborating with ProApptive to bring our platform to the Dutch market.",
    slug: "proapptive-partnership",
    publishDate: "2025-11-11",
    readingTime: "5 min read",
    author: {
      name: "Joanna Williams",
      image: "/team/joanna_williams.jpeg"
    },
    hero: {
      image: "/collaborative-team.jpg",
      imageAlt: "StudyStash and ProApptive partnership announcement"
    },
    
    contentBlocks: [
      {
        type: "heading",
        level: 1,
        text: "Overview"
      },
      {
        type: "image",
        src: "/netherlands_cover.png",
        alt: "StudyStash and ProApptive partnership in the Netherlands",
        width: 1600,
        height: 900
      },
      {
        type: "paragraph",
        text: "StudyStash is partnering with ProApptive to bring our AI-powered study platform to higher education institutions across the Netherlands."
      },
      {
        type: "paragraph",
        text: "The collaboration combines ProApptive's local expertise with StudyStash's proven approach to helping universities deliver personalised, student-centred learning experiences."
      },
      {
        type: "heading",
        level: 2,
        text: "The Netherlands: A Market Primed for Innovation"
      },
      {
        type: "paragraph",
        text: "Dutch universities are facing a measurable surge in demand for student support. A 2024 report from Caring Universities – a collaboration including Vrije Universiteit Amsterdam, Leiden University, and Utrecht University – found that 39.8% of students experience high levels of study stress, and 68% felt they needed psychological support last year."
      },
      {
        type: "paragraph",
        text: "That same pressure feeds into first-year attrition. A July 2024 study showed that 30% of first-year students either drop out or switch courses, with 25% at research universities and 34% at universities of applied sciences citing mismatched expectations. Helping students build confidence from day one is critical."
      },
      {
        type: "paragraph",
        text: "Institutions are simultaneously racing to implement trustworthy AI. While the Netherlands leads in digital infrastructure, a 2023 survey across EU institutions revealed that 80% still lack formal AI policies, even as universities such as TU Delft invest in large-scale \"AI and Learning Analytics\" initiatives. StudyStash’s \"AI with Guardrails\" approach offers a timely, safe framework."
      },
      {
        type: "paragraph",
        text: "The multilingual reality adds another layer. Although the Netherlands is renowned for English-taught programmes, Dutch remains dominant at bachelor level, and 16.2% of international students are enrolled in Dutch-taught bachelor programmes. StudyStash supports students seamlessly in both Dutch and English to ensure no learner is left behind."
      },
      {
        type: "heading",
        level: 2,
        text: "What the partnership delivers"
      },
      {
        type: "paragraph",
        text: "Together, we are launching tailored onboarding, training, and support packages for Dutch universities looking to scale AI-driven learning support in a safe, student-first environment."
      },
      {
        type: "paragraph",
        text: "ProApptive will lead local enablement while StudyStash provides the technology, insights, and best practices already trusted by institutions across Europe."
      },
      {
        type: "heading",
        level: 2,
        text: "The Lecturer Workload Crisis"
      },
      {
        type: "paragraph",
        text: "Dutch higher education excellence rests on lecturers who are under immense pressure. A 2024 Labor Inspectorate report found that 74% of teaching and research staff experience significant stress from work pressure, with 36% reporting high to very high exhaustion and an average of six hours of overtime each week."
      },
      {
        type: "paragraph",
        text: "By delivering adaptive, 24/7 learning support and automated formative feedback, StudyStash reduces the workload overhead and gives educators time back for high-impact teaching and research."
      },
      {
        type: "heading",
        level: 2,
        text: "The International Student Paradox"
      },
      {
        type: "paragraph",
        text: "International students now comprise 16.6% of the Dutch student body and 27.2% at research universities, yet their first-year dropout rate sits at 17%—far higher than domestic peers. Retention, not recruitment, is the new priority."
      },
      {
        type: "paragraph",
        text: "StudyStash equips students with bilingual, neuroscience-based support in Dutch and English so they can build successful study habits and stay on track from day one."
      },
      {
        type: "heading",
        level: 2,
        text: "A National Mandate for Digital Innovation"
      },
      {
        type: "paragraph",
        text: "With the €560 million Npuls programme funding digital transformation across every Dutch university, institutions are expected to accelerate innovation while staying focused on proven outcomes. The Dutch EdTech market is projected to grow at over 24% annually."
      },
      {
        type: "paragraph",
        text: "Our partnership with ProApptive provides a scalable, secure AI platform that aligns with this national mandate and helps universities invest confidently in future-ready, student-centred learning."
      },
      {
        type: "heading",
        level: 2,
        text: "Want to learn more?"
      },
      {
        type: "quote",
        text: "Working with ProApptive allows us to accelerate how we help Dutch universities deliver impactful learning experiences with StudyStash.",
        author: "Alan Teece",
        title: "StudyStash | Chief Marketing Officer",
        image: "/team/alan.jpg"
      },
      {
        type: "paragraph",
        text: "Discover our Dutch pilot offer or reach out to our team to explore how the partnership can support your goals."
      },
      {
        type: "button-row",
        buttons: [
          {
            type: "cta-button",
            text: "Discover our pilot offer",
            href: "/nl-pilot",
            variant: "primary",
            size: "lg"
          },
          {
            type: "cta-button",
            text: "Get in touch",
            href: "/contact-us",
            variant: "outline",
            size: "lg"
          }
        ]
      },
      {
        type: "sources",
        title: "Sources & References",
        items: [
          {
            id: "caring-universities-v-report-2024",
            title: "The mental well-being of university students in the Netherlands (V-report)",
            authors: ["Caring Universities"],
            date: "2024",
            url: "https://moodlift.nl/wp-content/uploads/2024/09/The-mental-well-being-of-students-V-report-by-Caring-Universities-26092024.pdf",
            type: "other",
            publication: "Caring Universities",
            description: "Highlights that 39.8% of Dutch students report high study stress and 68% felt they needed psychological support in the past year."
          },
          {
            id: "erudera-dropout-report-2024",
            title: "Wrong Course Choices Are Leading to Dropouts at Dutch Universities, Report Says",
            authors: ["Erudera"],
            date: "July 2024",
            url: "https://erudera.com/news/wrong-course-choices-are-leading-to-dropouts-at-dutch-universities-report-says/",
            type: "article",
            publication: "Erudera",
            description: "Reports that 30% of Dutch first-year students drop out or switch courses, citing mismatched expectations."
          },
          {
            id: "unesco-ai-guidance-2023",
            title: "UNESCO survey: Less than 10% of schools and universities have formal guidance on AI",
            authors: ["UNESCO"],
            date: "2023",
            url: "https://www.unesco.org/en/articles/unesco-survey-less-10-schools-and-universities-have-formal-guidance-ai",
            type: "article",
            publication: "UNESCO",
            description: "Finds that 80% of surveyed institutions lack formal AI policies, underscoring the need for trustworthy adoption."
          },
          {
            id: "nuffic-international-students-2025",
            title: "Fact sheet on international students in the Netherlands 2025",
            authors: ["Nuffic"],
            date: "2025",
            url: "https://www.expatcentremaastrichtregion.nl/recent/news/nuffic-fact-sheet-international-students-netherlands-2025",
            type: "other",
            publication: "Nuffic",
            description: "Validates that international students represent 16.6% of enrolment overall, 27.2% at research universities, with a 17% first-year dropout rate."
          },
          {
            id: "erasmus-magazine-labour-authority-2024",
            title: "Labour Authority: universities not in control of overtime, bullying and misbehaviour",
            authors: ["Erasmus Magazine"],
            date: "May 2024",
            url: "https://www.erasmusmagazine.nl/en/2024/05/16/labour-authority-universities-not-in-control-of-overtime-bullying-and-misbehaviour/",
            type: "article",
            publication: "Erasmus Magazine",
            description: "Covers the Dutch Labour Inspectorate report showing 74% of university staff facing serious work pressure and 36% high exhaustion."
          },
          {
            id: "vu-npuls-2025",
            title: "What is Npuls and what does it mean for you?",
            authors: ["Vrije Universiteit Amsterdam"],
            date: "2025",
            url: "https://vu.nl/en/news/2025/what-is-npuls-and-what-does-it-mean-for-you",
            type: "article",
            publication: "VU Amsterdam",
            description: "Explains the €560 million Npuls programme accelerating digital innovation across Dutch higher education."
          }
        ]
      }
    ],
    
    seo: {
      title: "StudyStash partners with ProApptive | StudyStash",
      description: "StudyStash and ProApptive are partnering to bring AI-powered learning support to Dutch universities. Learn how the collaboration can support your institution.",
      canonical: "https://studystash.com/about/events-webinars/proapptive-partnership"
    },
    
    relatedContent: ["educause", "eab-connected25", "digifest"]
  }
};